<template>
  <div class="contact-blocked-wrapper flex center-all">
    <div
      id="contact-blocked"
      class="info flex center-all"
      @click.stop>
      <p>Why I am seeing this?</p>
      <SBIcon
        :icon="SBIconList.INFO"
        :color="SBColors.blackPrimary"
        :size="12"/>
      <b-popover
        target="contact-blocked"
        triggers="hover"
        placement="auto"
        custom-class="big red">
        <div>
          <h1>Contact is blocked</h1>
          <p>Blocked contacts can't send you or receive messages from you.</p>
        </div>
      </b-popover>
    </div>
    <div
      class="contact-blocked flex center-all"
      @click="unblock()" >
      <p>This contact is blocked. Click to unblock.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'ContactBlocked',
  components: {
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    conversation: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
    }),
  },
  methods: {
    ...mapActions({
      blockContact: 'contact/blockContact',
    }),
    ...mapMutations({
      REMOVE_BLOCKED_FLAG_FROM_CONVERSATION: 'chat/REMOVE_BLOCKED_FLAG_FROM_CONVERSATION',
    }),
    unblock() {
      let message;
      if (this.conversation.contact.name) {
        message = `Are you sure you want to unblock contact <b>${this.conversation.contact.name}</b> ${this.$options.filters.phoneFormat(this.conversation.contact.phone)}?`;
      } else {
        message = `Are you sure you want to unblock contact <b>${this.$options.filters.phoneFormat(this.conversation.contact.phone)}</b>?`;
      }
      this.$confirmPluginModal.show({
        title: 'Unblock contact',
        message,
        confirmButtonText: 'Unblock',
        autoClose: 'true',
        confirmCallback: () => {
          this.blockContact({
            businessId: this.$route.params.businessId,
            conversationId: this.conversation.id,
            data: {
              block: '0',
              includeMe: true,
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.activeConversation.blocked = false;
                this.REMOVE_BLOCKED_FLAG_FROM_CONVERSATION(this.conversation.id);
                this.showToaster(`${this.conversation.contact.name ? this.conversation.contact.name : this.conversation.contact.phone} has been successfully unblocked.`, null, null, 'OK');
                this.$confirmPluginModal.close();
              }
            })
            .catch(() => {
              this.showToaster(`There was an error while unblocking ${this.conversation.contact.name ? this.conversation.contact.name : this.conversation.contact.phone}. Try again later.`, null, null, 'error');
            });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-blocked-wrapper {
  position: relative;
  .info {
    position: absolute;
    top: -28px;
    cursor: default;
    padding: 3px 9px;
    z-index: 51;
    border-radius: 10px;
    background-color: $white;

    p {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.4;
      color: $blackPrimary;
    }

    .sb-icon {
      margin-left: 5px;
    }
  }

  .contact-blocked {
    cursor: default;
    border-radius: 5px;
    padding: 9px;
    margin: 0 15px 15px;
    background-color: $greyUltralight;
    border: none;
    width: 100%;

    &:hover {
      background-color: #f0f4f5;
      cursor: pointer;
    }

    .sb-icon {
      margin-right: 5px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;
      color: $blackPrimary;
    }
  }
}
</style>
